window.featuredBanner = function () {
  'use strict';

  $('.slider-img').slick({
    lazyLoad: 'progressive',
    dots: false,
    arrows: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    asNavFor: ".slider-text"
  });

  $('.slider-text').slick({
    lazyLoad: 'progressive',
    dots: true,
    arrows: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    appendDots: $(".ghost-div .dots-slideshow"),
    asNavFor: ".slider-img",
  });
}
